import React from "react";
import PropTypes from "prop-types";
import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

const StyledSkeletonContainer = styled("div")(({ theme, noborder }) => ({
  width: "100%",
  ...(noborder === "false" && { border: "1px solid #e1e1e6" }),
  "& .MuiSkeleton-root": {
    height: 25,
  },
  "& .header": {
    borderBottom: "1px solid #e1e1e6",
    padding: theme.spacing(1.5),
  },
  "& .body": {
    padding: theme.spacing(1.5),
  },
  "& .bodyImage": {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(1.5),
  },
  "& .footer": {
    borderTop: "1px solid #e1e1e6",
    padding: theme.spacing(1.5),
    backgroundColor: "#f6f6fa",
  },
}));

const SFSkeleton = (props) => {
  const rows = [];

  for (let index = 0; index < props.rows; index++) {
    let randomWidth = Math.floor(Math.random() * (90 - 70) + 70); // Generate random width between 70 and 90
    rows.push(
      <Skeleton
        key={index}
        animation={props.animation}
        sx={{ width: `${randomWidth}%` }}
      />
    );
  }
  return (
    <StyledSkeletonContainer noborder={props.noBorder.toString()}>
      {props.showHeader && (
        <div className="header">
          <Skeleton animation={props.animation} />
        </div>
      )}
      {props.showBodyImage && (
        <div className="bodyImage">
          <Skeleton variant="circular" width={90} height={90} />
        </div>
      )}
      {props.showBody && <div className="body">{rows}</div>}
      {props.showFooter && (
        <div className="footer">
          <Skeleton animation={props.animation} />
        </div>
      )}
    </StyledSkeletonContainer>
  );
};

SFSkeleton.defaultProps = {
  showBodyImage: false,
  rows: 6,
  animation: "wave",
  showHeader: true,
  showBody: true,
  showFooter: true,
  noBorder: false,
};

SFSkeleton.propTypes = {
  layout: PropTypes.array,
  rows: PropTypes.number,
  animation: PropTypes.oneOf(["wave", "pulse", false]),
  showHeader: PropTypes.bool,
  showBody: PropTypes.bool,
  showFooter: PropTypes.bool,
  showBodyImage: PropTypes.bool,
  noBorder: PropTypes.bool,
};

export default SFSkeleton;
